import React, { SVGAttributes } from "react";
import styled from "styled-components";

const Styled = styled.g`
  polygon,
  circle {
    fill: #1fa4e1;
    fill-opacity: 0;
    transition:
      fill-opacity 0.2s,
      stroke-width 0.2s,
      fill 0.2s;
  }

  &:hover {
    polygon,
    circle {
      fill: #6dc4ec;
      fill-opacity: 0.1;
      stroke-width: 3;
    }
  }

  line {
    fill: none;
    stroke: #1fa4e1;
    stroke-width: 2;
  }
`;

interface Props extends SVGAttributes<SVGGElement> {}

const CartesianShape: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <Styled {...props}>{props.children}</Styled>;
};

export default CartesianShape;
